<template>
  <v-container fluid grid-list-md class="tp-page" style="padding: 30px;">
    <template v-if="!addUser">
      <!-- Cabeçalho -->
      <div class="tp-page-head">
        <div>
          <h1 class="tp-page-title">Turmas</h1>
          <p class="tp-page-sub">{{ eventos.length }} no total</p>
        </div>
        <div class="tp-head-actions">
          <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
          <v-btn color="#00695C" dark depressed rounded class="tp-btn-add" @click="dialogInicialReplicar">
            <v-icon left>mdi-plus-circle-outline</v-icon>Cadastrar
          </v-btn>
        </div>
      </div>

      <!-- Tabela -->
      <v-card class="tp-card" elevation="0">
        <v-data-table :search="search" :headers="headers" :items="eventos" sort-desc>
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-3" color="#00695C" @click="editItem(item)">edit</v-icon>
            <v-icon small color="error" @click="deleteItem(item)" v-if="companyobj.agenda || companyobj.vigilante">delete</v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="#00695C" text @click="carregaDados">Recarregar</v-btn>
          </template>
        </v-data-table>
      </v-card>
    </template>

    <!-- CARD INSERE USUARIOS -->
    <v-card v-else class="tp-card tp-form" elevation="0">
      <template v-if=" adicionarEvento">
        <v-card-title>
          <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <p style="font-size:15px; color:#00695C"> *O preenchimento de todos os campos é obrigatório</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#00695C"></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.descricao" outlined label="Descrição" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.vagas" outlined label="Vagas" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.reserva" outlined label="Reservas" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.inicio" placeholder="01/01/2020 00:00:00" v-mask="'##/##/#### ##:##:##'" outlined label="Início" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.fim" placeholder="01/01/2020 00:00:00" v-mask="'##/##/#### ##:##:##'" outlined label="Fim" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-if="!companyobj.vigilante">
                <v-text-field v-model="editedItem.urlLive" outlined label="URL da Live" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select v-model="editedItem.exigePagamento" outlined label="Exige Pagamento" color="#00695C" :items="exigePagamento" hide-details item-text="text" item-value="value"></v-select>
              </v-col> 
              <v-col cols="12" sm="12" md="12" v-if="companyobj.vigilante">
                <v-select v-model="editedItem.qualificacoes" outlined label="Qualificações Permitidas" color="#00695C" :items="qualificacoes" hide-details item-text="text" item-value="value" multiple></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-if="companyobj.vigilante">
                <p>Detalhes:</p>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.vlApoio" prefix="R$" outlined label="Diária Apoio" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.vlBasico" prefix="R$" outlined label="Diária Básico" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.vlGrandesEventos" prefix="R$" outlined label="Diária Grandes Eventos" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.hrInicio" outlined label="Hora Início" v-mask="'##:##'" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.hrApresentacao" outlined label="Hora Apresentação" v-mask="'##:##'" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.hrFim" outlined label="Hora Término" v-mask="'##:##'" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.endereco" outlined label="Endereço/Localização" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                  <p>Traje</p>
                  <v-radio-group
                    v-model="editedItem.traje"
                    mandatory
                  >
                    <v-radio
                      label="SOCIAL"
                      value="SOCIAL"
                    ></v-radio>
                    <v-radio
                      label="OPERACIONAL"
                      value="OPERACIONAL"
                    ></v-radio>
                  </v-radio-group>
              </v-col>  
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                  <p>Incluso Alimentação</p>
                  <v-radio-group
                    v-model="editedItem.alimentacao"
                    mandatory
                  >
                    <v-radio
                      label="SIM"
                      value="SIM"
                    ></v-radio>
                    <v-radio
                      label="NÃO"
                      value="NÃO"
                    ></v-radio>
                  </v-radio-group>
              </v-col>             
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="#00695C" text large @click="close">Cancelar</v-btn>
          <v-btn color="#00695C" dark depressed rounded large class="tp-btn-add px-6" @click="save">Salvar</v-btn>
        </v-card-actions>
      </template>

      <v-dialog v-else v-model="dialog" max-width="500px" persistent>
        <v-card light>
          <v-container>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 v-if="true">
                <br>
                <v-autocomplete light v-model="tipoSelecionado" :items="eventosCadastrados" item-value="id" item-text="nome" label="Escolha um Evento"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-checkbox v-model="checkbox1" :label="`Incluir inscritos`" color="#00695C" style="float: left; margin-right: 30px"></v-checkbox>
            <v-btn color="#00695C" text large @click="close">Cancelar</v-btn>
            <v-btn color="#00695C" dark depressed rounded large class="tp-btn-add px-6" @click="avancarReplicar()">Avançar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <v-dialog v-model="dialogReplicarEvento" max-width="500px" persistent>
      <v-card light class="tp-card">
        <v-container>
          <h4 class="tp-serif" style="text-align: center;color:#00253E;font-weight:600">Deseja replicar algum evento?</h4>
          <v-flex xs12 sm12 lg3>
            <template>
              <div>
              </div>
            </template>
          </v-flex>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00695C" text large @click.native="replicarNao()">Não</v-btn>
          <v-btn color="#00695C" ref="confirmar" dark depressed rounded large class="tp-btn-add px-6" @click.native="replicarSim()">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      limitado: true,
      faixas: [],
      search: '',
      addUser: false,
      dialog: false,
      dialogReplicarEvento: false,
      adicionarEvento: false,
      checkbox1: false,
      eventosCadastrados: [],
      tipoSelecionado: '',
      id_evento: '',
      temInscritos: false,
      exigePagamento: [
        { text: 'SIM', value: true, },
        { text: 'NÃO', value: false, },
      ],
      headers: [
        { text: 'Nome', align: 'start', value: 'nome', },
        { text: 'Descrição', value: 'descricao' },
        { text: 'Vagas', align: 'center', value: 'vagas' },
        { text: 'Reservas', align: 'center', value: 'reserva' },
        { text: 'Data Início', value: 'inicio' },
        { text: 'Data Fim', value: 'fim' },
        { text: 'Ações', value: 'action', align: 'center', sortable: false },
      ],
      qualificacoes: ['APOIO', 'VIGILANTE BÁSICO', 'VIGILANTE DE GRANDES EVENTOS'],
      eventos: [],
      editedIndex: -1,
      editedItem: {
        nome: '',
        descricao: '',
        vagas: '',
        reserva: '',
        inicio: '',
        fim: '',
        empresaId: '',
        urlLive: '',
        qualificacoes: [],
        vlApoio: '',
        vlBasico: '',
        vlGrandesEventos: '',
        hrInicio: '',
        hrApresentacao: '',
        hrFim: '',
        endereco: '',
        traje: '',
        alimentacao: '',
        exigePagamento: false,
      },
      inscricoesItem: [{
        cod_incricao: '',
        nome: '',
        cpf: '',
        sexo: '',
        telefone: '',
        tipo: '',
        eventoId: '',
        checkin: '',
        checkout: '',
      }],
      defaultItem: {
        nome: '',
        descricao: '',
        vagas: '',
        reserva: '',
        inicio: '',
        fim: '',
        empresaId: '',
        urlLive: '',  
        qualificacoes: [],
        vlApoio: '',
        vlBasico: '',
        vlGrandesEventos: '',
        hrInicio: '',
        hrApresentacao: '',
        hrFim: '',
        endereco: '',
        traje: '',
        alimentacao: ''
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'ADICIONAR NOVO EVENTO ' : 'EDITAR EVENTO'
      }
    }),

    created() {

    },

    mounted() {
      this.carregaDados()
    },

    watch: {
      dialogReplicarEvento() {
        if (!this.dialogReplicarEvento) return
        requestAnimationFrame(() => {
          this.$refs.confirmar.$el.focus()
        })
        this.checkbox1 = false
      }
    },

    methods: {
      async avancarReplicar() {
        var vm = this
        this.temInscritos = false
        try {
          let res = await axios.get(`${baseApiUrl}Eventos?filter[where][id]=${this.tipoSelecionado}&access_token=${sessionStorage.getItem('accToken')}`)
          if (this.tipoSelecionado != '') {
            let dataInicio = res.data[0].inicio.split('-')
            let dataFim = res.data[0].fim.split('-')
            this.editedItem.nome = res.data[0].nome
            this.editedItem.descricao = res.data[0].descricao
            this.editedItem.vagas = res.data[0].vagas
            this.editedItem.reserva = res.data[0].reserva
            this.editedItem.inicio = dataInicio[2].substring(0, 2) + dataInicio[1] + dataInicio[0]
            this.editedItem.fim = dataFim[2].substring(0, 2) + dataFim[1] + dataFim[0]
            if (this.checkbox1 == true) {
              try {
                let res = await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"eventoId": +"${this.tipoSelecionado}"}}&access_token=${sessionStorage.getItem('accToken')}`)
                if (res.data != '') {
                  this.inscricoesItem = res.data
                  this.dialogReplicarEvento = false
                  this.adicionarEvento = true
                  this.temInscritos = true
                } else {
                  vm.$refs.chamaSnackbar.snack("error", "Não foram encontrados inscritos para este evento.")
                }
              } catch (error) {
                vm.$refs.chamaSnackbar.snack("error", "Erro ao buscar inscritos para este evento.")
              }
            } else {
              this.dialogReplicarEvento = false
              this.adicionarEvento = true
            }
          }
        } catch (error) {
          vm.$refs.chamaSnackbar.snack("error", "Erro ao consultar eventos.")
        }
      },

      async replicarSim() {
        this.tipoSelecionado = '';
        this.adicionarEvento = false;
        this.dialog = true;
      },

      async replicarNao() {
        this.editedItem.exigePagamento = false
        this.dialogReplicarEvento = false;
        this.adicionarEvento = true;
      },

      async dialogInicialReplicar() {
        this.adicionarEvento = false;
        this.dialog = false;
        this.dialogReplicarEvento = true;
        this.verificaDisponibilidade();
      },

      async carregaDados() {
        this.isLoading = true
        await axios.get(`${baseApiUrl}Eventos?filter={"where":{"igrejaId":"${this.user.igrejaId}"}, "order":"inicio DESC"}&access_token=${sessionStorage.getItem('accToken')}`)
        .then(res => {
          if (res.data != '') {
            this.eventos = []
            //this.eventos = res.data
            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                /* if(this.formatDate(res.data[key].inicio.substr(0, 10)) >= this.formatDateBrz(new Date().toISOString().substr(0, 10)))
                  { */
                this.eventos.push({
                  'nome': res.data[key].nome,
                  'descricao': res.data[key].descricao,
                  'vagas': res.data[key].vagas,
                  'reserva': res.data[key].reserva,
                  'inicio': this.formatDate(res.data[key].inicio.substr(0, 10)) + " " + res.data[key].inicio.substr(11, 8),
                  'fim': this.formatDate(res.data[key].fim.substr(0, 10)) + " " + res.data[key].fim.substr(11, 8),
                  'empresaId': res.data[key].empresaId,
                  'id': res.data[key].id,
                  'urlLive': res.data[key].urlLive,
                  'qualificacoes': res.data[key].qualificacoes,
                  'vlApoio': res.data[key].vlApoio,
                  'vlBasico': res.data[key].vlBasico,
                  'vlGrandesEventos': res.data[key].vlGrandesEventos,
                  'hrInicio': res.data[key].hrInicio,
                  'hrApresentacao': res.data[key].hrApresentacao,
                  'hrFim': res.data[key].hrFim,
                  'endereco': res.data[key].endereco,
                  'traje': res.data[key].traje,
                  'alimentacao': res.data[key].alimentacao,
                  'exigePagamento': res.data[key].exigePagamento
                });
                /*  } */
              }
            }
            this.eventos = this.eventos.sort(this.compare)
            if (res.data != null) {
              this.eventosCadastrados = res.data
            }
            this.isLoading = false
          } else {
            this.isLoading = false
          }
        })
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()
        let comparison = 0;
        if (dataC >= dataA) {
          comparison = 1;
        } else if (dataC < dataA) {
          comparison = -1;
        }
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      openDialog() {
        this.dialog = true
      },

      editItem(item) {
        this.editedIndex = this.eventos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.adicionarEvento = true
        this.addUser = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir o Evento: ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(`${baseApiUrl}Eventos/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          .then(() => {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaDados()
          })
        }
      },

      close() {
        this.dialogReplicarEvento = false
        this.addUser = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save() {
        this.isLoading = true
        if (this.editedIndex != -1) {
          this.editedItem.vagas = parseInt(this.editedItem.vagas)
          this.editedItem.reserva = parseInt(this.editedItem.reserva)
          this.editedItem.inicio = moment(this.formatDatePadrao(this.editedItem.inicio)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z');
          this.editedItem.fim = moment(this.formatDatePadrao(this.editedItem.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z');
          await axios.patch(`${baseApiUrl}Eventos/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
          .then(res => {
            if (res.data != null) {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaDados()
            }
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
        } else {
          this.editedItem.empresaId = this.companyobj.id
          this.editedItem.igrejaId = this.user.igrejaId
          this.editedItem.tipo = 'EM'
          this.editedItem.vagas = parseInt(this.editedItem.vagas)
          this.editedItem.reserva = parseInt(this.editedItem.reserva)
          this.editedItem.inicio = moment(this.formatDatePadrao(this.editedItem.inicio)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z');
          this.editedItem.fim = moment(this.formatDatePadrao(this.editedItem.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z');
          await axios.post(`${baseApiUrl}Eventos/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
            .then(res => {
              this.id_evento = res.data.id
              if (res.data != null) {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#0288D1", "Evento cadastrado com sucesso!", "INFORMAÇÃO")
                this.carregaDados()
              }
            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar evento, tente novamente", "ERRO")
            })
          if (this.temInscritos == true) {
            for (var i = 0; i < this.inscricoesItem.length; i++) {
              this.inscricoesItem[i].eventoId = this.id_evento
              this.inscricoesItem[i].id = undefined
              this.inscricoesItem[i].checkin = null
              this.inscricoesItem[i].checkout = null
              await axios.post(`${baseApiUrl}Inscricoes?access_token=${sessionStorage.getItem('accToken')}`, this.inscricoesItem[i])
              .catch(() => {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao salvar as inscrições", "ERRO")
              })
            }
          }
        }
        this.close()
      },

      async verificaDisponibilidade() {
        var creditoFaixa = []
        this.faixas = []
        await axios.get(`${baseApiUrl}Empresas?filter[where][id]=${this.companyobj.id}&access_token=${sessionStorage.getItem('accToken')}`)
          .then(res => {
            creditoFaixa = res.data[0].creditoFaixa
          })
        if (creditoFaixa.faixa1 != 0) {
          this.limitado = true
          this.faixas.push(30)
          this.addUser = true
        }
        if (creditoFaixa.faixa2 != 0) {
          this.limitado = true
          this.faixas.push(60)
          this.addUser = true
        }
        if (creditoFaixa.faixa3 != 0) {
          this.limitado = true
          this.faixas.push(100)
          this.addUser = true
        }
        if (creditoFaixa.faixa4 != 0) {
          this.limitado = false
          this.addUser = true
        }
        if (creditoFaixa.faixa1 == 0 && creditoFaixa.faixa2 == 0 && creditoFaixa.faixa3 == 0 && creditoFaixa.faixa4 == 0) {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Você não possui créditos para a inclusão de um novo evento, entre em contato com a Intelite e solicite agora!", "ATENÇÃO")
        }
      }
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>